module.exports = __webpack_public_path__ + "static/media/cross.bc4070c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/MemberProfile/cross.svg
// module id = 362
// module chunks = 0